import { Article } from '@api/api';
import { articleApiClient } from '@api/clients';
import { queries } from '@consts/queries';
import { useArticlesCount } from '@queries/useArticlesCount';
import { useQuery, UseQueryResult } from 'react-query';

const limit = 6;
const startLimit = 6;

export const fetchLatestStoriesSidebar = async ({
  itemsLimit = 3,
}: {
  itemsLimit?: number;
}): Promise<Article[]> => {
  const { data } = await articleApiClient.articlesLatestNewsGet({ limit: itemsLimit });

  return data;
};

export const fetchLatestStories = async ({
  pageParam = 0,
}: {
  pageParam?: number;
}): Promise<{ page: number; items: Article[] }> => {
  const { data } = await articleApiClient.articlesGet(
    { limit: pageParam ? limit : startLimit, start: pageParam ?? 0 },
    { params: queries.latestStories },
  );

  return { page: pageParam, items: data };
};

export const useLatestStories = (page = 0): UseQueryResult & { totalPages: number } => {
  const { data: articlesCount } = useArticlesCount(queries.latestStories);

  return {
    totalPages: Math.ceil(articlesCount / limit),
    ...useQuery(
      ['latest-stories', page],
      () =>
        fetchLatestStories({
          pageParam: page * limit,
        }),
      {
        keepPreviousData: true,
      },
    ),
  };
};
